import { render } from "./Chat.vue?vue&type=template&id=03ebd03d&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"

import "./Chat.vue?vue&type=style&index=0&id=03ebd03d&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/KAYBU/mi-stock/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03ebd03d"]])

export default __exports__